define([
    "jwplayer",
    "templates/infohelper-template.handlebars",
    "underscore",
    "less/infohelper.less"
],function(jwplayer,_template,_){
  module.exports = jwplayer().registerPlugin('infohelper', '6.0',
    function(player, config, infohelperElement){
      var defaultOptions = {
        show: false,
        showAndPause: false,
        content: ''
      }
      var o  = $.extend(defaultOptions,config)
      var _w, _h
      var $wrapper = $(infohelperElement), $template, $button, pannelID
      var hideLayer = function () {
        $template.fadeOut().hide(function(){
          if (o.showAndPause) {
            if (player.getState() == 'paused') player.play()
          }
        })
        o.show = false
        $button.find('a').css('background-image', 'url("' + o.buttonImg + '")')
      }
      var showLayerAndPause = function () {
        setWH()
        if (o.showAndPause) {
          if (player.getState() == 'playing') player.pause()
        }
        $button.find('a').css('background-image', 'url("' + o.buttonImgActive + '")')
        $template.fadeIn().show()
        o.show = true
      }
      var setWH = function() {
        $template.css("width", _w).css("height",_h)
        $template.find('.bg').css("width", _w * .3).css("height",_h).css("left", _w * .7)
        $template.find('.infohelper-panel').css("width", _w * .3).css("height",_h).css("left", _w * .7)
      }
      // document.getElementsByClassName('jw-controlbar-right-group')[0].appendChild()
      var setup = function(evt){
        pannelID = '#' + player.id + 'infohelper'
        var temp =_template({
            htmlContent: o.content,
            o:o,
            wid:pannelID
        })
        $wrapper.append(temp);
        // $template.css("width",_w).css("height",_h)
        // dom
        $button = o.button = $('<div class="infohelper-button jw-icon jw-icon-tooltip jw-button-color jw-reset"><a href="javascript:void(0);"></a></div> ')
        o.button.insertAfter($('#' + player.id).find('.jw-controlbar-right-group > span'))
        o.button.find('a').css('background-image', 'url("' + o.buttonImg + '")')
        $button.on('click', function (e) {
          console.log(e)
          if (!o.show) {
            showLayerAndPause()
          } else {
            hideLayer()
          }
        })

        $template = $wrapper.find('.infohelper-panel-wrapper')
        _w = _w ? _w : $wrapper.width()
        _h = _h ? _h : $wrapper.height()
        setWH()

        console.log($template)
        if (o.show) {
          showLayerAndPause()
        } else if (player.getState() === 'playing'){
          hideLayer()
        }
        $wrapper.on('resize', function (e) {
          setWH()
        })
        $wrapper.find('.x-btn').click(function(e){
          hideLayer()
        })
      }
      player.onTime(function(t){

      })
      player.onError(function(e){
          // console.log(e);
      })
      player.onReady(setup)
      this.resize = function(w,h){
        _w = w
        _h = h
        if ($wrapper) $wrapper.trigger('resize')
      }
      o.buttonImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpDOTUxNzAxOTQzQTIxMUU5QTJGRUVFNjg4MURBMTI3NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo5NzRGNTNERDNCRUQxMUU5QkY5REE3REY3MjU4MDZEQiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5NzRGNTNEQzNCRUQxMUU5QkY5REE3REY3MjU4MDZEQiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjgxNTFhMzU3LTZjNDYtNDE1YS04MzljLWYzNTgxYzU4OTc0MyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDOTUxNzAxOTQzQTIxMUU5QTJGRUVFNjg4MURBMTI3NyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmonmEEAAAD+SURBVHjanJI/CsIwGMXT0gNY6OLgIhTpGRy8gaOCq5tQdwfnDm4Kbg4OCjr2Bg6eQcRRcCqtN6jvyReI8Q/SBz+SfHmPhC9xyrJUWkVRtDGMQQ1cpdwAdzD3ff+ovY4OIpRgGIAV2MF0lnoLQx8MwRb1yTPAYJ7nCTiBiGupzYixjsSTPA/DpANuINQmMWbEqoXi7Xg4dAQWuMJFvWpqrRU9uPqCGVcasVfvagq26K0xmBkdNNUVbNGbeeq78h97iicG8lb/it7AlcftfTA4gi167wwuQYxuhZahLpg/i56YGRctPmCyBik2IsO3EXSIeym9zFT+ck7VT/4QYABtg64p+MpeWAAAAABJRU5ErkJggg=='
      o.buttonImgActive = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRjhDNDY4NDQzQTMxMUU5QkJGRkU4ODQ4ODQ0QUQ5RCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo5NzRGNTNENTNCRUQxMUU5QkY5REE3REY3MjU4MDZEQiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5NzRGNTNENDNCRUQxMUU5QkY5REE3REY3MjU4MDZEQiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjYyZjM1MmZlLTIzZmEtNGU3Ni04ZTE2LWEwNTgyZjk1NzRiOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRjhDNDY4NDQzQTMxMUU5QkJGRkU4ODQ4ODQ0QUQ5RCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PiOjx30AAAECSURBVHjanNK/CwFhGAfw93R1g12xn0FZbBajQVGKIn+AFGUyy2hS/AOKKEqh+wMY/AHKYjfYJaX4PvW9ensdg6c+d3Xv93nv12OlehelVQFKEIYzr7lwgyWs/aCtnUeQhTnM4Mi1JFRhADlowtNvHPJOGTjxWp/nDjeZwA5e0LC5SxHS2uNJ1bVGxQ0ls4eNNNb4mHqTVFt91pnZWggHBxYBoSiZJVlHGq9wCQjkySzJXm31ve4/1pTcMQKxgLUnmSXZiDQ+oBwQeJFZkn1I45Q/1TUCcdLLZXYq7+jBCg7GAIyNpgQHQL6q53+cFliw1Uaua4xchfMqWWX9O+RvAQYAzEk8Xfje0tkAAAAASUVORK5CYII='
    }
  )
})



//////////////////
// WEBPACK FOOTER
// ./src/webpack/infohelper.js
// module id = 0
// module chunks = 3